import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import cx from "classnames";
import { Link } from "react-router-dom";
import { useTranslate } from "../../hooks/useTranslate";
import "./Navigation.css";

const NavigationItem = (props) => {
    const {
        icon: Icon, isActive, titleKey, link, disabled,
        onItemClick,
    } = props;
    const { t } = useTranslate();

    return (
        <ListItemButton
            key={titleKey}
            component={Link}
            to={link}
            className={cx("Navigation__item", { "Navigation__item--active": isActive })}
            disabled={disabled}
            onClick={onItemClick}
        >
            {Icon && (
                <ListItemIcon className="Navigation__item-icon">
                    <Icon />
                </ListItemIcon>
            )}
            <ListItemText className="Navigation__item-title" primary={t(`navigation.${titleKey}`)} />
        </ListItemButton>
    );
};

export default NavigationItem;
